// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RegistrationEdit
 */
export interface RegistrationEdit {
    /**
     * 
     * @type {string}
     * @memberof RegistrationEdit
     */
    status: RegistrationEditStatusEnum;
    /**
     * Additional metadata
     * @type {object}
     * @memberof RegistrationEdit
     */
    metadata?: object;
}

/**
    * @export
    * @enum {string}
    */
export enum RegistrationEditStatusEnum {
    Learning = 'learning',
    Pause = 'pause',
    Success = 'success',
    Fail = 'fail',
    Abort = 'abort'
}



